import { Component, Inject, OnInit, signal } from "@angular/core";
import { AngularFireAnalytics } from "@angular/fire/compat/analytics";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { DomSanitizer } from "@angular/platform-browser";
import { Data } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { of } from "rxjs";
import { map } from "rxjs/operators";
import { StoreRepositoryService } from "../store-repository.service";
import { IonicModule } from "@ionic/angular";
interface Product {
  productDescription: string;
}
@Component({
    selector: "app-product-info",
    templateUrl: "./product-info.component.html",
    styleUrls: ["./product-info.component.scss"],
    standalone: true,
    imports: [IonicModule, TranslatePipe],
})
export class ProductInfoComponent implements OnInit {
  public languageCode: string;
  public languageCodeSignal = signal<string>("")
  productInfo$ = this.storeService.selectedProduct$.pipe(
    map((data: string | Product | null) => {
      const result = data ?? of(null);
      const productData = data as Product;
      const productDetail = this.domSanitizer.bypassSecurityTrustHtml(productData?.productDescription ?? '');
      if (result !== null) {
        result["productDetail"] = productDetail;
      }
      return result;
    })
  );

  userId: string;
  constructor(
    private bottomSheetRef: MatBottomSheetRef<ProductInfoComponent>,
    private analytics: AngularFireAnalytics,
    private storeService: StoreRepositoryService,
    public domSanitizer: DomSanitizer,
    private authService: AuthService,
    public translate: TranslateService,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any
  ) {
    this.languageCode = "en";
    // Subscribe to userDetails$ observable
    this.authService.userDetails$.subscribe({
      next: (user: Data) => {
        // Extract language code from user data or default to 'en'
        this.languageCodeSignal.set(user?.language_code || "en");
        this.languageCode = this.languageCodeSignal();
        // Set the language for translation
        translate.use(this.languageCodeSignal());
        // Log event after getting user details
      },
      error: (err) => {
        return err;
      },
    });
  }

  async ngOnInit() {
    await this.authService
      ?.getUid("ProductInfoComponent")
      ?.then((uid) => {
        this.userId = uid;
        this.analytics.logEvent("product_info_modal", { userId: this.userId });
      })
      .catch((error: any) => {
        return error;
      });
  }

  closeBottomSheet() {
    this.bottomSheetRef.dismiss();
  }
}
